import { useEffect, useState } from "react";
import { formatCurrency, returnPractice } from "../../../lib/script";

export default function PracticesPart({activeCase,classes}) {

    const [totalCharges, setTotalCharges] = useState(0)
    const [totalBalance, setTotalBalance] = useState(0)

    useEffect (() => {
        if (activeCase?.practices) {
            let total_charges = 0
            let total_balance = 0
            activeCase.practices.forEach(element => {
                total_charges = total_charges + element.total_charges
                total_balance = total_balance + element.balance
            });

            setTotalCharges(total_charges)


            setTotalBalance(total_balance)
        }

    }, [activeCase?.practices])
    return <>
        <table>
            <thead>
                <tr>
                    <td>Type</td>
                    <td>Charges</td>
                    <td>Balance</td>
                </tr>
            </thead>
            <tbody>
                {activeCase.practices && activeCase.practices.map(item => (
                    <tr key={item.practice_id}>
                        <td>{returnPractice(item.practice_id)?.name}</td>
                        <td><b>{item.total_charges ? `$${formatCurrency(item.total_charges)}` : '-'}</b></td>
                        <td><b>{item.balance ? `$${formatCurrency(item.balance)}` : '-'}</b></td>
                    </tr>
                ))}

            </tbody>
        </table>

        <div className={`${classes.totals} ${classes.total_charges}`}>
            <div className={classes.totals_label}>Total charges</div>
            <div className={classes.totals_numbers}>
                ${formatCurrency(totalCharges)}
            </div>
        </div>
        <div className={`${classes.totals} ${classes.total_balance}`}>
            <div className={classes.totals_label}>Total balance</div>
            <div className={classes.totals_numbers}>
                ${formatCurrency(totalBalance)}
            </div>
        </div>
    </>
}